import { useUpdate } from '@refinedev/core';
import { FormStickyActions, FormSpacer } from '@/components/forms';
import type { SubscriptionPlan } from '../types';
import { SubscriptionPlanFormFields, buildPlanFormState } from './SubscriptionPlanFormFields';

interface SubscriptionPlanEditTabProps {
  plan: SubscriptionPlan;
  onUpdated: () => void;
}

export function SubscriptionPlanEditTab({ plan, onUpdated }: SubscriptionPlanEditTabProps) {
  const { mutateAsync: update, mutation } = useUpdate();

  const initial = buildPlanFormState(plan);

  return (
    <SubscriptionPlanFormFields
      key={`edit-${plan.id}`}
      isEdit
      formLoading={mutation.isPending}
      initialState={initial}
      renderFooter={(submit, isLoading) => (
        <>
          <FormSpacer />
          <form onSubmit={(e) => { e.preventDefault(); submit(); }}>
            <FormStickyActions
              primaryLabel="Сохранить"
              onPrimary={submit}
              isPending={isLoading}
              pendingLabel="Сохранение..."
            />
          </form>
        </>
      )}
      onFinish={async (data) => {
        await update({
          resource: 'subscription-plans',
          id: plan.id,
          values: data,
          meta: { endpoint: 'admin' },
        });
        onUpdated();
      }}
    />
  );
}
